import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import store from '@/store';
import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/assistenza',
            name: 'villageChatDetail',
            component: () => import("./views/assistenza.vue"),
            meta: {
                hasBar: true,
                appContainerClass: 'fullPage'
            }
        },
    ];
};